import { Id, ModulePlacement } from '@ess/jg-rule-executor';

export class MarkerPlacement {
  constructor(
    public mainMarkers: Map<Id<ModulePlacement>, string>,
    public visualXMarkers: Map<Id<ModulePlacement>, string[]>
  ) {
  }
}
